// AddBill — modal-embedded form for creating a Bill of Lading row.
// Refactored 2026-05-05 (Phase 3.3, Class P) onto ModalFormHeader.

import React, { useEffect, useState } from "react";
import CTextField from "../CTextField/CTextField";
import {
  Button, Select, MenuItem, FormControl, Stack, Box,
} from "@mui/material";
import { LocalShippingOutlined } from "@mui/icons-material";
import { useDispatch } from "react-redux";
import { showErrorToast, showSuccessToast } from "../../utils/Toast";
import ApiCall from "../../utils/apicall";
import { createBill } from "../../feature/shippinglistSlice";
import { ModalFormHeader, FieldLabel } from "../PaperForm";

const AddBill = (props) => {
  const dispatch = useDispatch();
  const [quantity, setQuantity] = useState("");
  const [billid, setbillid] = useState("");
  const [bill, setbill] = useState([]);
  const [poid, setpoid] = useState("");
  const [po, setpo] = useState([]);

  useEffect(() => {
    const getitem = async () => {
      const res = await ApiCall.get("/fabricated-items/getall-fabricated-item");
      const uniqueJobIds = new Set();
      const filteredJob = res.data.data.filter((dataItem) => {
        if (!uniqueJobIds.has(dataItem.name)) {
          uniqueJobIds.add(dataItem.name);
          return true;
        }
        return false;
      });
      setbill(filteredJob);
    };
    getitem();
  }, []);

  useEffect(() => {
    const getitem = async () => {
      const res = await ApiCall.get("/purchaseorder");
      setpo(res.data.data.purchaseOrders);
    };
    getitem();
  }, []);

  const handleSubmit = () => {
    if (!billid) { showErrorToast("Please select a Fabricated Item"); return; }
    if (!quantity) { showErrorToast("Please enter a Quantity"); return; }
    const billData = {
      fabricated_items: billid,
      purchase_order: poid,
      quantity: quantity,
    };
    dispatch(createBill(billData)).then((res) => {
      if (res.type === "createBill/Bill/fulfilled") {
        showSuccessToast("Bill of Lading created successfully!");
        props.setOpen(false);
      }
      if (res.type === "createBill/Bill/rejected") {
        showErrorToast("Bill already exists.");
      }
    });
  };

  const handlebillSelection = (event) => { setbillid(event.target.value); };
  const handlepoSelection = (event) => { setpoid(event.target.value); };

  return (
    <Box>
      <ModalFormHeader
        overline="SFM · Bill of Lading"
        title="Add Bill of Lading"
        icon={LocalShippingOutlined}
      />
      <Stack spacing={2}>
        <Box>
          <FieldLabel required>Fabricated Item</FieldLabel>
          <FormControl fullWidth size="small">
            <Select
              value={billid}
              onChange={handlebillSelection}
              displayEmpty
              variant="outlined"
              sx={{ textAlign: "left" }}
            >
              <MenuItem value=""><em>Select fabricated item…</em></MenuItem>
              {bill.map((dataItem) => (
                <MenuItem key={dataItem.id} value={dataItem.id}>{dataItem.name}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
        <Box>
          <FieldLabel hint="optional · associated PO">Purchase Order</FieldLabel>
          <FormControl fullWidth size="small">
            <Select
              value={poid}
              onChange={handlepoSelection}
              displayEmpty
              variant="outlined"
              sx={{ textAlign: "left" }}
            >
              <MenuItem value=""><em>Select PO number…</em></MenuItem>
              {po.map((dataItem) => (
                <MenuItem key={dataItem.id} value={dataItem.id}>{dataItem.po_number}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
        <CTextField
          margin="0px"
          onChange={(event) => setQuantity(event.target.value)}
          name="quantity"
          label="Quantity"
          required
        />
        <Button
          disabled={props.isLoading}
          onClick={handleSubmit}
          variant="contained"
          sx={{
            width: "100%",
            mt: 1,
            borderRadius: 2,
            textTransform: "none",
            fontWeight: 600,
            letterSpacing: "0.01em",
          }}
        >
          {props.isLoading ? "Loading…" : "Create Bill of Lading"}
        </Button>
      </Stack>
    </Box>
  );
};

export default AddBill;
